module.exports = __webpack_public_path__ + "static/media/joblist.903b512a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/assets/joblist.svg
// module id = 588
// module chunks = 20